module.exports = __webpack_public_path__ + "img/al-kola.288be8ff.jpg";